<app-system-maintenance *ngIf="showMessage" (closeModal)="closeModal($event)"></app-system-maintenance>

<ng-container>
  <mapfre-card [singleCard]="false" [additionalClasses]="'billing-new-container'"
    [ngClass]="{ 'col-363636' : isAcmic }">
    <div class="hello-label">
      {{ "Hello" | translate }}
      <ng-container *ngIf="userFirstName?.length > 0"> {{ userFirstName | translate | titlecase }}</ng-container>,
    </div>

    <div class="home-greeting-container mt-1">
      <span>{{ "WELCOME_TO_HOMEPAGE" | translate }}</span>
      <span class="web-break"><br></span>
      {{ "FIND_ACCONT_INFO" | translate }}
    </div>
    <app-non-renewal-notice *ngIf="tokenReady"></app-non-renewal-notice>
    <div [ngClass]="{'mt-4': isAcmic, 'top-space': !isAcmic}">
      <app-carousel-banner></app-carousel-banner>
    </div>

    <div class="frequent-action-label mb-2" [ngClass]="{'mt-4': isAcmic, 'top-space': !isAcmic}">
      {{ "FREQUENT_ACTION" | translate }}
    </div>
    <div class="frequent-action-info fs-18 mb-3">{{ "CUSTOMIZE_ACTIONS" | translate }}</div>

    <app-action-widget></app-action-widget>
  </mapfre-card>
</ng-container>